var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 1)?_c('SchoolTeacherAwayControl'):(_vm.type === 2)?_c('SchoolStaffAwayControl'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }